export const symbol = {
	EUR: '€',
	SEK: 'kr',
};
